<template>
  <div class="columns review-card">
    <div class="column padding-0 is-narrow is-hidden-mobile dot-section">
      <span class="dot blue-dot"></span>
    </div>
    <div class="column padding-left-mobile-0 padding-right-mobile-0">
      <div class="columns">
        <div class="column is-8 padding-0 margin-bottom-15 review-title">
          <div class="columns is-block">
            <div class="column padding-0">
              <b class="bold-text">{{review.review_title}}</b>
            </div>
            <div class="column padding-0 rating">
              <div class="columns is-flex-mobile">
                <div class="column padding-0">
                  <Rating :stars="review.review_rating"></Rating>
                </div>
                <div class="column padding-0 is-hidden-tablet is-hidden-desktop has-text-right">
                  <i>{{review.created_at|prettyDate}}</i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column padding-0">
          <div class="columns is-block">
            <div class="column is-hidden-mobile padding-0 padding-bottom-2"><b><i>Written by: {{review.author.first_name}} {{review.author.last_name}}</i></b></div>
            <div class="column is-hidden-mobile padding-0"><b><i>Written at: {{review.created_at|prettyDate}}</i></b></div>
            <div class="column internal-info"><span class="italic">Status:</span> &nbsp;&nbsp;&nbsp;&nbsp;
              <span class="reply-status" :class="[{'replied': review.messages.length}, {'unreplied': !review.messages.length}]">{{review.messages.length ? 'Replied' : 'Unreplied'}}</span>
            </div>
            <div class="column is-inline-flex flex-align-centre internal-info">
              <span class="italic">Channel:</span> &nbsp;&nbsp;&nbsp;
              <span class="is-inline-flex flex-align-centre">
                <img src="/static/img/logo/hellopeter.svg" alt="hellopeter" width="15" height="15"> &nbsp;&nbsp;
                Hellopeter
                <!--<img src="/static/img/social/google/google-mini.png" alt="hellopeter" width="15" height="15"> &nbsp;&nbsp;
                Google-->
              </span>
            </div>
            <!--<div class="column is-hidden-mobile internal-info">
              <span class="italic">Branch:</span>
              <span class="capsule">
                <i>Branch</i> &nbsp;<img src="/static/img/home/capsule_x.svg">
              </span>
            </div>-->
          </div>
        </div>
      </div>
      <div class="columns is-hidden-mobile attachments">
        <div class="column padding-top-0 padding-bottom-0 padding-left-0 is-narrow" v-for="attachment in review.attachments">
          <img :src="`${attachment.attachment_folder_url}${attachment.attachment_name}`" alt="attachment" width="30" height="30">
        </div>
      </div>
      <div class="columns is-inline text-region">
        {{ (!showMore ? review.review_content.substring(0, 326) : review.review_content) + (review.review_content.length > 326 && !showMore ? '...' : '')}}
        <span class="show-more" v-if="!showMore" data-track="Portal Home Show More/Less To Show User and Review Details" @click="handleShowMore">{{showMore ? `Show less` : `Show more`}}</span>
      </div>
      <div class="quick-reply-section">
        <!-- Reply now button Begins -->
        <div class="columns is-hidden-mobile" v-if="options.quickReplyButton && !review.messages.length && localQuickReplyButton">
          <div class="column padding-left-0 padding-bottom-0">
            <button class="button is-button-dark-blue is-uppercase" data-track="Portal Home Quick Reply Button" :class="[{'is-disabled': (modal.open && !showMore)}]" :disabled="modal.open && !showMore" @click="modal.open=!modal.open">Reply Now</button>
          </div>
        </div> <!-- Reply now button Ends -->
        <!-- Quick reply modal Begins -->
        <div class="quick-reply-modal" v-if="modal.open && !showMore">
          <div class="columns is-block">
            <div class="column padding-bottom-0 has-text-right">
              <img src="/static/img/ads/modal_close.svg" alt="close" class="cursor" @click="modal.open=!modal.open">
            </div>
            <div class="column padding-top-0 padding-bottom-0">
              <wysiwyg
                name="reply"
                shouldClear="yes"
                value=""
                class="wysiwyg"
                :pre-saved-responses="true"
                @input="handleReplyChange"
              />
            </div>
            <div class="column is-flex flex-align-centre flex-justify-end padding-left-0 has-text-right padding-top-0">
              <div class="column is-flex flex-align-centre is-narrow padding-top-0 padding-right-0 padding-bottom-0" v-if="isPaidSubscriptionForReply">
                <input type="radio" :value="true" v-model="reply.public">&nbsp;  Public reply
              </div>
              <div class="column is-flex flex-align-centre is-narrow padding-top-0 padding-right-0 padding-bottom-0" v-if="isPaidSubscriptionForReply">
                <input type="radio" :value="false" v-model="reply.public">&nbsp;  Private reply
              </div>
              <div class="column is-narrow padding-top-0 padding-right-0 padding-bottom-0">
                <button class="button is-button-dark-blue is-uppercase" :class="[{'is-loading': isLoading}]" @click="handleReply">Reply Now</button>
              </div>
            </div>
          </div>
        </div>
      </div> <!-- Quick reply modal Ends -->
      <!-- Reply section Begins -->
      <div class="reply-section" :class="[{'add-padding-top': (reviewStats.totalReviews === 1 && reviewStats.totalReplied === 0 && !showMore)}]" v-if="showReplySection">
        <div class="columns flex-align-centre is-flex-mobile" v-if="0">
          <div class="column padding-left-0 padding-top-0 is-flex flex-align-centre">
            <avatar
              color="#fff"
              :size="30"
              backgroundColor="#1261a0"
              :username="`${review.author.first_name} ${review.author.last_name}`"
            >
            </avatar>&nbsp;&nbsp;&nbsp;
            <b>{{review.author.first_name}} {{review.author.last_name ? review.author.last_name.charAt(0).toUpperCase() : ''}}</b>
          </div>
          <div class="column padding-right-0 padding-top-0 has-text-right is-hidden-mobile" v-if="0">
            <a :href="`${app.frontendURL}/profile/${review.author.user_uuid}`" target="_blank" class="show-more" data-track="Portal Home To Show Consumer Business">View user history</a>
          </div>
        </div>
        <!-- User info Begins -->
        <div class="user-info" v-if="showMore">
          <div class="columns is-block upgrade-section" v-if="!isPaidSubscription && !isFreeSubscription">
            <div class="column"><b>You have no more review credits for the month.</b></div>
            <div class="column">
              <img src="/static/img/free-lock-icon.png" alt="upgrade">&nbsp;&nbsp;&nbsp;
              <span><router-link data-track="Portal Home To Renew/Upgrade Subscription" :to="`/renew-or-upgrade-subscription`" class="show-more">Upgrade</router-link> to view contact details now or wait for your monthly plan to renew.</span>
            </div>
          </div>
          <div class="columns is-block upgrade-section-not-from-source" v-if="!isPaidSubscription && 0">
            <div class="column">
              <img src="/static/img/free-lock-icon.png" alt="upgrade">&nbsp;&nbsp;&nbsp;
              <span><router-link data-track="Portal Home To Renew/Upgrade Subscription" :to="`/renew-or-upgrade-subscription`" class="show-more">Upgrade</router-link> to gain access to more user details.</span>
            </div>
          </div>
          <div class="columns is-block details" v-if="isPaidSubscription">
            <div class="column padding-bottom-7">
              <div class="columns is-flex-mobile">
                <div class="column padding-0 is-4 is-one-third-mobile">
                  <span><b>Reviewer Details: </b></span>
                </div>
                <div class="column padding-0 is-8 is-one-third-mobile has-text-right">
                  <a :href="`${app.frontendURL}/profile/${review.author.user_uuid}`" target="_blank" class="show-more" data-track="Portal Home To Show Consumer Business">View Reviewer History</a>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="columns is-flex-mobile">
                <div class="column padding-0 is-2 is-one-third-mobile">
                  <span><b>Full name:</b></span>
                </div>
                <div class="column padding-0">
                  <span>{{review.author.first_name}} {{review.author.last_name}}</span>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="columns is-flex-mobile">
                <div class="column padding-0 is-2 is-one-third-mobile">
                  <span><b>ID:</b></span>
                </div>
                <div class="column padding-0">
                  <span>{{review.author.id_number || '-'}}</span>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="columns is-flex-mobile">
                <div class="column padding-0 is-2 is-one-third-mobile">
                  <span><b>Email:</b></span>
                </div>
                <div class="column padding-0">
                  <span>{{review.author.email}}</span>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="columns is-flex-mobile">
                <div class="column padding-0 is-2 is-one-third-mobile">
                  <span><b>Mobile:</b></span>
                </div>
                <div class="column padding-0">
                  <span>{{review.author.phone}}</span>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="columns is-flex-mobile">
                <div class="column padding-0 is-2 is-one-third-mobile">
                  <span><b>Review source:</b></span>
                </div>
                <div class="column padding-0">
                  <span>{{reviewSource}}</span> <!--Landing page invite-->
                </div>
              </div>
            </div>
            <div class="column">
              <div class="columns is-flex-mobile">
                <div class="column padding-0 is-2 is-one-third-mobile">
                  <span><b>Ref number:</b></span>
                </div>
                <div class="column padding-0">
                  <span>{{ getIncidentReference(review.incident_ref_number, review.incident_id_number, review.incident_account_number) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div> <!-- User info Ends -->
        <!-- Add your reply section Begins -->
        <div
          class="add-reply-external"
          v-if="showReplyBoxForDesktop"
        > <!-- options.quickReplyBox-->
          <div class="columns is-block add-your-reply-section">
            <div class="column">
              <span class="add-reply-header">{{reply.editMode ? 'Edit' : 'Add'}} your reply</span>
            </div>
            <div class="column">
              <wysiwyg
                name="reply"
                :pre-saved-responses="isPaidSubscriptionForReply"
                shouldClear="yes"
                :value="reply.editMode ? review.messages[0].body : ''"
                class="wysiwyg"
                @input="handleReplyChange"
              />
            </div>
            <div class="column is-flex flex-align-centre flex-justify-end padding-left-0 has-text-right padding-top-0">
              <div class="column is-flex flex-align-centre is-narrow padding-top-0 padding-bottom-0" v-if="!reply.editMode && isPaidSubscriptionForReply">
                <input type="radio" :value="true" v-model="reply.public">&nbsp;  Public reply &nbsp;&nbsp;
              </div>
              <div class="column is-flex flex-align-centre is-narrow padding-top-0 padding-bottom-0" v-if="!reply.editMode && isPaidSubscriptionForReply">
                <input type="radio" :value="false" v-model="reply.public">&nbsp;  Private reply &nbsp;&nbsp;
              </div>
              <div class="column is-narrow padding-top-0 padding-right-0 padding-bottom-0">
                <button
                  data-track="Portal Home Add Reply"
                  class="button is-button-dark-blue is-uppercase"
                  :class="[{'is-loading': isLoading}]"
                  @click="handleReply"
                >
                  Reply Now
                </button>
              </div>
            </div>
          </div>
        </div> <!-- Add your reply section Ends -->
        <!-- Add your reply section Begins -->
        <div
          class="add-reply-external is-hidden-desktop is-hidden-tablet"
          v-if="showReplyBoxForMobile"
        > <!-- options.quickReplyBox-->
          <div class="columns is-block add-your-reply-section">
            <div class="column">
              <span class="add-reply-header">{{reply.editMode ? 'Edit' : 'Add'}} your reply</span>
            </div>
            <div class="column">
              <wysiwyg
                name="reply"
                :pre-saved-responses="isPaidSubscriptionForReply"
                shouldClear="yes"
                :value="reply.editMode ? review.messages[0].body : ''"
                class="wysiwyg"
                @input="handleReplyChange"
              />
            </div>
            <div class="column is-flex flex-align-centre flex-justify-end padding-left-0 has-text-right padding-top-0">
              <div class="column is-flex flex-align-centre is-narrow padding-top-0 padding-bottom-0" v-if="!reply.editMode && isPaidSubscriptionForReply">
                <input type="radio" :value="true" v-model="reply.public">&nbsp;  Public reply &nbsp;&nbsp;
              </div>
              <div class="column is-flex flex-align-centre is-narrow padding-top-0 padding-bottom-0" v-if="!reply.editMode && isPaidSubscriptionForReply">
                <input type="radio" :value="false" v-model="reply.public">&nbsp;  Private reply &nbsp;&nbsp;
              </div>
              <div class="column is-narrow padding-top-0 padding-right-0 padding-bottom-0">
                <button class="button is-button-dark-blue is-uppercase" data-track="Portal Home Add Reply" :class="[{'is-loading': isLoading}]" @click="handleReply">Reply Now</button>
              </div>
            </div>
          </div>
        </div> <!-- Add your reply section Ends -->
        <!-- Replied section Begins -->
        <div class="replied-section" v-if="(review.messages.length && showMore && !reply.editMode)">
          <div class="columns is-block margin-bottom-0 replied">
            <div class="column is-flex-desktop is-flex-tablet is-block-mobile padding-left-0 padding-right-0">
              <div class="column header">{{user.businessName}}’s reply</div>
              <div class="column has-text-right-desktop has-text-right-tablet reply-time">Replied at: {{review.messages[0].updated_at|prettyDate}}</div>
            </div>
            <div class="column is-block">
              <div class="column" v-html="review.messages[0].body"></div>
            </div>
          </div> <!-- Replied section Ends -->
          <div class="columns">
            <div class="column has-text-right">
              <span class="show-more" @click="reply.editMode=true">Edit</span>&nbsp;&nbsp;
              <span class="show-more" data-track="Portal Home Delete Reply" @click="deleteReply">Delete</span>
            </div>
          </div>
        </div> <!-- Replied section Ends -->
        <hr class="divider" v-if="showMore">
        <div class="columns has-text-right" v-if="showMore">
          <div class="column padding-0">
            <span class="show-more" data-track="Portal Home Show Less" @click="handleShowMore">Show less</span>&nbsp;&nbsp;
            <span class="show-more" data-track="Portal Home Cancel Edit Mode" @click="reply.editMode=isFormChanged=false" v-if="reply.editMode">Cancel edit</span>
          </div>
        </div>
      </div>
      <!-- Reply section Ends -->
    </div>
  </div>
</template>

<script>
  /* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape, valid-jsdoc */
  import axios from 'axios'
  import moment from 'moment'
  import { misc } from '@/mixins'
  import Avatar from 'vue-avatar'
  import Rating from '@/components/Rating'
  import Wysiwyg from '@/components/Wysiwyg'

  export default {
    name: 'ReviewCard',
    mixins: [misc],
    components: {
      Avatar,
      Rating,
      Wysiwyg
    },
    props: {
      options: {
        type: Object,
        required: true
      },
      review: {
        type: Object,
        required: true
      },
      reviewStats: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        isFormChanged: false,
        isLoading: false,
        app: {
          frontendURL: `${process.env.HP_APP_URL}`
        },
        reply: {
          value: '',
          public: true,
          editMode: false,
          replyUrl: '',
          requestType: 'post'
        },
        user: {
          first_name: localStorage.getItem('first_name'),
          last_name: localStorage.getItem('last_name'),
          businessSlug: localStorage.getItem('org_slug'),
          businessName: localStorage.getItem('org_name')
        },
        modal: {
          open: false
        },
        showMore: false,
        localQuickReplyButton: true
      }
    },
    created () {
      console.log()
    },
    computed: {
      /**
       * Check the user type whether it is having Paid plan
       * @return {boolean}
       */
      isPaidSubscription () {
        // If user having Other than Free business
        return this.userInfo.subscription.name !== 'Free'
      },
      /**
       * Check the user type whether it is having Free plan
       * @return {boolean}
       */
      isFreeSubscription () {
        // If user having Free business
        return this.userInfo.subscription.name === 'Free'
      },
      /**
       * Check the user type whether it is having Premium plan
       * @return {boolean}
       */
      isPaidSubscriptionForReply () {
        // If user having Premium plan
        return (['P1', 'P2', 'P3', 'P4']).includes(this.userInfo.subscription.name.toUpperCase())
      },
      /**
       * Check if app is in mobile view
       * @return {boolean}
       */
      isMobile () {
        if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          return true
        } else {
          return false
        }
      },
      /**
       * Get the review source where it is written
       * @return {string}
       */
      reviewSource () {
        if (this.review.invite && this.review.invite.is_sms_conversion) {
          return 'SMS Invite'
        }
        return (this.review.invite && this.review.invite.type === 'INMAIL') ? `In mail invite` : `Landing page invite`
      },
      /**
       * Check when to show the reply section and user details
       * @return {boolean}
       */
      showReplySection () {
        return (
          // When totalReview = 1 AND Mobile View AND No replies, Then to show reply box in without show more condition
          (this.reviewStats.totalReviews === 1 && this.isMobile && !this.review.messages.length) ||
          // When totalReview = 1 AND Desktop View AND No replies AND no show More, Then to show reply box in without show more condition
          (this.reviewStats.totalReviews === 1 && !this.isMobile && !this.review.messages.length && !this.showMore) ||
          // When totalReview = 1 AND Mobile View AND having replies AND show More clicked, Then to show user info and reply
          (this.reviewStats.totalReviews === 1 && this.isMobile && this.review.messages.length && this.showMore) ||
          // When totalReview = 1 AND Desktop View AND having replies AND show More clicked, Then to show user info and reply
          (this.reviewStats.totalReviews === 1 && !this.isMobile && this.review.messages.length && this.showMore) ||
          // When totalReview = 1 AND Desktop View AND no replies AND show More clicked, Then to show user info and reply
          (this.reviewStats.totalReviews === 1 && !this.isMobile && !this.review.messages.length && this.showMore) ||
          // When totalReview more than 1 AND Desktop View AND show More clicked, Then to show user info and reply
          (this.reviewStats.totalReviews >= 2 && !this.isMobile && this.showMore) ||
          // When totalReview more than 1 AND Mobile View AND show More clicked, Then to show user info and reply
          (this.reviewStats.totalReviews >= 2 && this.isMobile && this.showMore)
        )
      },
      /**
       * Check when to show the reply box in mobile view
       * @return {boolean}
       */
      showReplyBoxForMobile () {
        return (
          // When totalReview more than 1 AND Mobile View AND no replies AND show More clicked, Then show reply box for mobile
          (this.reviewStats.totalReviews > 1 && this.isMobile && !this.review.messages.length && this.showMore) ||
          // When totalReview more than 1 AND Mobile View AND having replies AND in Edit mode of reply AND show More clicked, Then show reply edut box for mobile
          (this.reviewStats.totalReviews > 1 && this.isMobile && this.review.messages.length && this.reply.editMode && this.showMore) ||
          // When totalReview is 1 AND Mobile View AND no replies Then show reply box for mobile outside of show More link
          (this.reviewStats.totalReviews === 1 && this.isMobile && !this.review.messages.length) ||
          // When totalReview is 1 AND Mobile View AND having reply AND in reply edit mode Then show reply edut box for mobile
          (this.reviewStats.totalReviews === 1 && this.isMobile && this.review.messages.length && this.reply.editMode)
        )
      },
      /**
       * Check when to show the reply box in desktop/tablet view
       * @return {boolean}
       */
      showReplyBoxForDesktop () {
        return (
          // When totalReview more 1 AND Desktop View AND in reply edit mode AND Show more clicked Then show reply edit box for Desktop
          (this.reviewStats.totalReviews >= 2 && !this.isMobile && this.reply.editMode && this.showMore) ||
          // When totalReview more 1 AND Desktop View AND in reply mode AND Show more clicked Then show reply box for Desktop
          (this.reviewStats.totalReviews >= 2 && !this.isMobile && !this.reply.editMode && !this.review.messages.length && this.showMore) ||
          // When totalReview is 1 AND Desktop View AND (no reviews OR in Edit mode) Then show reply edit box for Desktop outside of show more link
          (this.reviewStats.totalReviews === 1 && !this.isMobile && (!this.review.messages.length || this.reply.editMode))
        )
      }
    },
    methods: {
      /**
       * Handle show more/less functionality
       * @returns {void}
       */
      handleShowMore () {
        this.showMore = !this.showMore
        this.localQuickReplyButton = !this.showMore
        axios(`/${this.user.businessSlug}/reviews/${this.review.permalink}?isHpAdminMenu=${window.localStorage.is_admin_menu_active}&businessSlug=${window.localStorage.org_slug}`)
        .then(({data}) => {
          window.events.$emit('loadHeaderStats')
        })
      },
      /**
       * Handle when user changes a reply in reply box
       * @returns {void}
       */
      handleReplyChange (reply) {
        this.reply.value = reply
        this.isFormChanged = true
      },
      /**
       * Handle edit/add reply to review functionality
       * @returns {void}
       */
      handleReply () {
        let msgType = ''
        let dataObj = {}
        if (this.reply.editMode) {
          msgType = `edited`
          this.reply.requestType = 'put'
          this.reply.replyUrl = `admin/${this.user.businessSlug}/reviews/${this.review.slug}/reply/${this.review.messages[0].id}`
          dataObj = {
            content: this.reply.value.trim()
          }
        } else {
          msgType = `added`
          this.reply.requestType = 'post'
          this.reply.replyUrl = `/replies/reviews/${this.review.permalink}`
          dataObj = {
            reply: this.reply.value.trim(),
            public: this.reply.public
          }
        }
        if (this.reply.value.trim()) {
          this.isLoading = true
          axios(`/${this.user.businessSlug}/reviews/${this.review.permalink}?isHpAdminMenu=${window.localStorage.is_admin_menu_active}&businessSlug=${window.localStorage.org_slug}`)
          .then(({data}) => {
            window.events.$emit('loadHeaderStats')
            axios[this.reply.requestType](this.reply.replyUrl, dataObj)
            .then(({ data }) => {
              window.events.$emit('loadHeaderStats')
              this.reply.editMode = this.modal.open = this.isLoading = this.isFormChanged = false
              dataLayer.push({
                'userMessage': {
                  'messageType': 'success',
                  'messageName': `Reply ${msgType} successfully`,
                  'displayedMessage': `Reply ${msgType} successfully`
                }
              })
              flash(`Reply ${msgType} successfully.`, 'is-success')
              window.events.$emit('updateAppearance')
            })
          })
        }
      },
      /**
       * Handle and emit event to delete a reply
       * @returns {void}
       */
      deleteReply () {
        window.events.$emit('deleteReply', this.review.messages[0].id)
      }
    },
    filters: {
      /**
       * Creating date format same as - 20 April 2020 at 8:01pm
       * @param val
       * @returns {string}
       */
      prettyDate (val) {
        return moment(val).format('DD MMMM YYYY [at] hh:mma')
      }
    }
  }
</script>

<style lang="scss" scoped>
$replied: #17be86;
$unreplied: #f99c50;
$blue-color: #1261a0;
$text-color: #58595b;

.review-card {
  color: $text-color;
  border: solid 1px #d8d8d8;
  padding: 12px;
  font-size: 12px;
  align-items: baseline;

  .review-title {
    padding: 0 35px 0 0;
  }
  .bold-text {
    font-size: 14px;
    font-weight: bold;
  }
  .dot-section {
    width: 3%;
    text-align: center;
  }
  .rating {
    >>>li {
      font-size: 1.2em;
      margin-left: 1px;
    }
  }
  .internal-info {
    padding: 1px 0;
  }
  .text-region {
    /*Mobile view*/
    @media screen and (max-width: 767px) {
      margin: 8% 0 0 0;
      display: block !important;
    }
  }
  .attachments {
    img {
      width: 30px;
      height: 30px;
    }
  }
  >>>.modal {
    .modal-card-body {
      p {
        font-size: 14px;
      }
    }
  }

  /*Mobile view*/
  @media screen and (max-width: 767px) {
    padding: 0 0 20px 0;
    border: none;
    border-top: solid 1px #d8d8d8;
  }
}
.italic {
  font-size: 11px;
  font-style: italic;
}
.reply-status {
  color: #fff;
  font-size: 10px;
  padding: 2px 9px;
  line-height: 2;
  border-radius: 14px;

  &.replied {
    background: $replied;
  }
  &.unreplied {
    background: $unreplied;
  }
}
.show-more {
  color: #30aae1;
  cursor: pointer;
  text-decoration: underline;
}
.is-button-dark-blue {
  width: 139px;
  height: 35px;
}
.dot {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-flex;

  &.blue-dot {
    background-color: $blue-color;
  }
}
.reply-section {
  color: $text-color;
  margin: 15px 0;
  padding: 1px 20px 30px 22px;
  background-color: #f7f7f7;

  .column {
    padding: 4px;
  }
  &.add-padding-top {
    padding-top: 23px;
  }
  .user-info {
    margin: 0 0 22px 0;
    background: #fcfcfc;

    .details {
      margin: 22px 0 0 0;
      padding: 10px 10px 20px 10px;
    }
    .upgrade-section {
      padding: 30px 20px;
    }
    .upgrade-section-not-from-source {
      padding: 45px 20px;
    }
  }
  .replied-section {
    padding: 0 20px 0 15px;

    .replied {
      padding: 10px 0 0 10px;
      border-left: solid 1px rgba(88, 89, 91, 0.32);

      .header {
        font-size: 14px;
        font-weight: bold;
      }

      .reply-time {
        font-size: 12px;
        font-style: italic;
        font-weight: bold;
      }

      /*Mobile view*/
      @media screen and (max-width: 767px) {
        padding: 0 0 0 15px;
      }
    }

    /*Mobile view*/
    @media screen and (max-width: 767px) {
      padding: 0 0 0 15px;
    }
  }

  /*Mobile view*/
  @media screen and (max-width: 767px) {
    position: absolute;
    left: 0;
    right: 0;
  }
}
.add-your-reply-section {
  padding: 12px 20px;
  background-color: #fcfcfc;

  .column {
    padding: 0;
  }
  .add-reply-header {
    font-size: 14px;
  }

  /*Mobile view*/
  @media screen and (max-width: 767px) {
    .is-button-dark-blue {
      width: 100%;
    }
  }
}
.capsule {
  font-size: 11px;
  border: solid 1px rgba(88, 89, 91, 0.32);
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  padding: 0 1px 0 7px;
  margin-left: 12px;
}
.divider {
  margin-top: 25px;
  border-bottom: 1px solid #dbdbdb;
  margin-bottom: 18px !important;
  padding-bottom: 0px !important;
}
.wysiwyg {
  border-color: #c9c9ca;
  margin: 4px 0 15px;

  >>>.trix-button-row {
    background-color: #fff !important;
    border-bottom: 1px solid #c9c9ca;
  }
  >>>trix-toolbar {
    .trix-button-group {
      margin-top: 5px !important;
      padding-left: 6px;
      margin-bottom: 4px;
    }
    .trix-button--icon-bold {
      width: 15px;
      margin-right: 3px;
    }
    .trix-button--icon-italic {
      width: auto;
      margin-right: 3px;
    }
    .trix-button--icon-bullet-list, .trix-button--icon-number-list {
      width: 21px;
      margin-right: 3px;

      &::before {
        left: 3px;
        width: 15px;
      }
    }
  }
  >>> trix-editor {
    padding: 10px;
    height: auto;
    min-height: 86px;

    &:empty:not(:focus)::before {
      color: rgba(88, 89, 91, 0.32);
    }
  }
}
.quick-reply-section {
  position: relative;

  >>> trix-editor {
    height: 65px;
    min-height: 65px;
    overflow-y: auto;
  }
}
.quick-reply-modal {
  width: 78%;
  padding: 0 5px 15px 5px;
  z-index: 9999;
  position: absolute;
  border-top: 5px solid #1261a0;
  border-radius: 2px;
  background-color: #ffffff;
  box-shadow: 2px 2px 6px 0 rgba(0, 0, 0, 0.16);
}
.button[disabled] {
  color: #fff !important;
  background-color: #CDCBCB !important;
}
/* Helper css begins */
.cursor {
  cursor: pointer;
}
.margin {
  &-0 {
    margin: 0;
  }
  &-bottom {
    &-0 {
      margin-bottom: 0;
    }
  }
}
.padding-bottom-2 {
  padding-bottom: 2px !important;
}
.padding-bottom-7 {
  padding-bottom: 7px !important;
}
.padding {
  &-0 {
    padding: 0;
  }
  &-top {
    padding-top: 0;

    &-bottom {
      &-2 {
        padding-bottom: 2px;
      }
      &-5 {
        padding: 0 5px;
      }
    }
  }
  &-left {
    &-mobile {
      &-0 {
        /*Mobile view*/
        @media screen and (max-width: 767px) {
          padding-left: 0;
        }
      }
    }
  }
  &-right {
    &-mobile {
      &-0 {
        /*Mobile view*/
        @media screen and (max-width: 767px) {
          padding-right: 0;
        }
      }
    }
  }
}
/* Helper css ends */
</style>



// WEBPACK FOOTER //
// src/components/home/ReviewCard.vue